import React from 'react';
import PropTypes from 'prop-types';

import { cn } from 'helpers/classnames';
import { TRACKING_STATUS } from 'constants/shippingStatuses';
import useMartyContext from 'hooks/useMartyContext';

import css from 'styles/components/account/expandedTrackingProgress.scss';

export const ExpandedTrackingProgress = ({ trackingInfo, dataMaskPiiElements }) => {
  const { testId } = useMartyContext();
  const { shipper, tracking, trackingNumber } = trackingInfo || {};
  const { statusCode, estimatedDeliveryDate } = tracking || {};
  const {
    SHIPPING_SOON,
    SHIPPED,
    IN_TRANSIT,
    OUT_FOR_DELIVERY,
    DELIVERED,
    DELAYED,
    RETURNING,
    RETURNED,
    UNDELIVERABLE,
    DELIVERY_ATTEMPTED,
    CUSTOMER_ACTION
  } = TRACKING_STATUS;

  const isDelivered = statusCode === DELIVERED;
  const isOutForDelivery = statusCode === OUT_FOR_DELIVERY || statusCode === UNDELIVERABLE || statusCode === DELIVERY_ATTEMPTED || isDelivered;
  const isInTransit =
    statusCode === IN_TRANSIT || statusCode === DELAYED || statusCode === RETURNING || statusCode === RETURNED || isOutForDelivery || isDelivered;
  const isShipped = statusCode === SHIPPED || isInTransit || isOutForDelivery || isDelivered;
  const isShippingSoon =
    statusCode === SHIPPING_SOON || statusCode === CUSTOMER_ACTION || isShipped || isInTransit || isOutForDelivery || isDelivered;

  const shippingSoonClasses = cn({
    [css.stepActive]: statusCode === SHIPPING_SOON,
    [css.stepComplete]: isShippingSoon
  });
  const shippedClasses = cn({
    [css.stepActive]: statusCode === SHIPPED,
    [css.stepComplete]: isShipped
  });
  const inTransitClasses = cn({
    [css.stepActive]: statusCode === IN_TRANSIT,
    [css.stepComplete]: isInTransit
  });
  const outForDeliveryClasses = cn({
    [css.stepActive]: statusCode === OUT_FOR_DELIVERY,
    [css.stepComplete]: isOutForDelivery
  });
  const deliveredClasses = cn({
    [css.stepActive]: statusCode === DELIVERED,
    [css.stepComplete]: isDelivered
  });

  return (
    <div className={css.shipmentDetails} data-cs-mask={dataMaskPiiElements} data-test-id={testId('expandedTrackingProgress')}>
      {estimatedDeliveryDate && (
        <h2>
          {isDelivered ? 'Delivered' : 'Estimated delivery'} on {estimatedDeliveryDate}
        </h2>
      )}
      <div className={css.trackingNumber}>
        {shipper} Tracking: {trackingNumber}
      </div>
      <div className={css.trackingProgress}>
        <ul className={css.steps}>
          <li className={cn(css.step, shippingSoonClasses)}>
            <span />
            <span>Processing</span>
          </li>
          <li className={cn(css.step, shippedClasses)}>
            <span />
            <span>Shipped</span>
          </li>
          <li className={cn(css.step, inTransitClasses)}>
            <span />
            <span>In transit</span>
          </li>
          <li className={cn(css.step, outForDeliveryClasses)}>
            <span />
            <span>Out for delivery</span>
          </li>
          <li className={cn(css.step, deliveredClasses)}>
            <span />
            <span>Delivered</span>
          </li>
        </ul>
      </div>
    </div>
  );
};

ExpandedTrackingProgress.contextTypes = {
  testId: PropTypes.func
};

ExpandedTrackingProgress.propTypes = {
  trackingInfo: PropTypes.object.isRequired
};

export default ExpandedTrackingProgress;
